import { v4 as uuidv4 } from 'uuid';

import * as actionTypes from './actionTypes';
import { getDefaultMessage } from './utils';

/**
 * @param {import('./types').Notification} notification
 */
export const enqueueNotification = notification =>
  /** @type import('./types').enqueueNotificationAction */
  ({
    type: actionTypes.ENQUEUE_NOTIFICATION_TOAST,
    payload: {
      key: uuidv4(),
      message: getDefaultMessage(notification.type),
      ...notification,
    },
  });

export const dequeueNotification = () =>
  /** @type import('./types').dequeueNotificationAction */
  ({
    type: actionTypes.DEQUEUE_NOTIFICATION_TOAST,
  });

/**
 * @param {import('./types').Notification} notification
 */
export const createNotification = ({ key = uuidv4(), ...notification }) =>
  /** @type import('./types').createNotificationAction */
  ({
    type: actionTypes.ADD_TOAST_NOTIFICATION,
    payload: {
      key,
      message: getDefaultMessage(notification.type),
      ...notification,
    },
  });
